import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { LogoSimpleIcon } from "../../../assets/icons/LogoSimpleIcon";

const Step2Form = ({
  formData,
  handleChange,
  formErrors,
  handleFileChange,
}) => {
  return (
    <div className="signup-box text-center mt-5">
      <LogoSimpleIcon />
      <h2 className="text-center">Créer votre devis</h2>
      {/* <p className="text-center">
        Créez votre espace sécurisé pour suivre vos simulations et projets
      </p> */}

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="activitySector">
            <Form.Label className="text-start w-100">
              Secteur d’activité *
            </Form.Label>
            <Form.Control
              name="activitySector"
              placeholder="Secteur d'activité *"
              value={formData.activitySector}
              onChange={handleChange}
              isInvalid={!!formErrors.activitySector}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.activitySector}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6} className="ps-0">
          <Form.Group controlId="company">
            <Form.Label className="text-start w-100">Entreprise *</Form.Label>
            <Form.Control
              name="company"
              placeholder="Nom de la société *"
              value={formData.company}
              onChange={handleChange}
              isInvalid={!!formErrors.company}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.company}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="servicesDemandes">
            <Form.Label className="text-start w-100">
              Types de services souhaités *
            </Form.Label>
            <Form.Control
              name="servicesDemandes"
              placeholder="Services demandés *"
              value={formData.servicesDemandes}
              onChange={handleChange}
              isInvalid={!!formErrors.servicesDemandes}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.servicesDemandes}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6} className="ps-0">
          <Form.Group controlId="dateSoumission">
            <Form.Label className="text-start w-100">
              Date de création de projet *
            </Form.Label>
            <Form.Control
              type="date"
              name="dateSoumission"
              placeholder="Date de soumission *"
              value={formData.dateSoumission}
              onChange={handleChange}
              isInvalid={!!formErrors.dateSoumission}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.dateSoumission}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={12} className="ps-0">
          <Form.Group controlId="description">
            <Form.Label className="text-start w-100">
              Description détaillée de votre projet *
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              placeholder="Description du projet *"
              value={formData.description}
              onChange={handleChange}
              isInvalid={!!formErrors.description}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.description}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="budgetEstime">
            <Form.Label className="text-start w-100">
              Budget estimé HT *
            </Form.Label>
            <Form.Control
              name="budgetEstime"
              placeholder="Budget estimé (€) *"
              value={formData.budgetEstime}
              onChange={handleChange}
              isInvalid={!!formErrors.budgetEstime}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.budgetEstime}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6} className="ps-0">
          <Form.Label className="text-start w-100">Devise *</Form.Label>
          <Form.Group controlId="devise">
            <Form.Select
              name="devise"
              value={formData.devise}
              onChange={handleChange}
              className="mb-2"
            >
              <option value="EUR">Euro (EUR)</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="KBIS">
            <Form.Label className="text-start w-100">KBIS *</Form.Label>
            <Form.Control
              type="file"
              name="KBIS"
              onChange={(e) => handleFileChange("KBIS", e)}
              className="mb-2"
            />
          </Form.Group>
        </Col>
        <Col md={6} className="ps-0">
          <Form.Group controlId="pieceJointe">
            <Form.Label className="text-start w-100">Pièce jointe *</Form.Label>
            <Form.Control
              type="file"
              name="pieceJointe"
              onChange={(e) => handleFileChange("pieceJointe", e)}
              className="mb-2"
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default Step2Form;
